module.exports = __webpack_public_path__ + "public/adminIcons/homepageSettings.svg?fa7ca30a";